// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"E4-z"};